<template src="./template.html"></template>

<script>
import JsonEx from 'vue-json-excel';
import GoogleMaps from 'reusable/Map';
import SelectC from 'reusable/Select';
import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue';
let Modal = () => import('reusable/Modal');
let LoadingModal = () => import('components/Modals/LoginModal');
import toastr from 'toastr';

export default {
	data() {
		return {
			info: {
				modalName: 'loading-modal',
			},
			jsonData: [],
			eventsFields: {
				Id: 'id',
				Fecha: 'fecha',
				Hora: 'hora',
				Lat: 'lat',
				Lng: 'lng',
				Km: 'km',
				Tipo: 'tipo',
				Estado: 'estado',
				Municipio: 'municipio',
			},
			middlePointsFields: {
				Id: 'id',
				Fecha: 'fecha',
				Hora: 'hora',
				Lat: 'lat',
				Lng: 'lng',
				Km: 'km',
				Eventos: 'tipo',
				Estado: 'estado',
				Municipio: 'municipio',
			},
			jsonFields: {},
			jsonMeta: [{ key: 'charset', value: 'utf-8' }],
			mcStyle: {
				height: '52vh',
				width: '100%',
			},
			wStyle: {
				padding: '0',
			},
			alarmType: undefined,
			date: this.$store.state.dpDate,
			option: this.$store.state.dpOpsHasta,
			option2: this.$store.state.dpOpsDesde,
			historico: [],
			historicoMiddlePoints: [],
			desde: '',
			hasta: '',
			ducto: '',
			ductos: [],
			tipo: null,
			isFormClosed: false,
			kmFrom: 0,
			kmTo: 10000,
			timer: null,
			validation: false,
			desdeText: '',
			hastaText: '',
			historicoTemp: [],
			selectedEventRow: null,
			selectedChartRange: 15,
			selectedTramo: null,
			selectedDucto: null,
			ductoFound: null,
			leak_id: null,
			leak_detail: false,
			isChartVisible: false,
		};
	},
	watch: {
		historico() {
			this.$refs.map.fillMap(this.historicoMiddlePoints);
		},
		historicoMiddlePoints() {
			this.$refs.map.fillMap(this.historicoMiddlePoints, this.ducto);
		},
		markersFill() {
			this.$refs.map.fillMark();
		},
	},
	methods: {
		loading() {
			document.querySelector('#loading-btn').click();
		},
		selectEvent(e) {
			this.ducto = document.querySelector(`#${e}`).value;
			this.ductoFound =
				this.ductos &&
				this.ductos.find((x) => x.id === Number(this.ducto));
			this.selectedDucto = this.ductoFound && this.ductoFound.ducto;
			console.log('Selected ducto:', this.selectedDucto);
		},
		validate(e, d) {
			this[d] = e;
			let max = this.hasta;
			let min = this.desde;
			if (max !== '' && (max <= min || min === '')) {
				this.desdeText = 'Este valor debe ser menor';
				this.hastaText = 'Este valor debe ser mayor';
				this.validation = false;
			} else {
				this.desdeText = '';
				this.hastaText = '';
				this.validation = true;
			}
		},
		historicoMark() {
			this.$refs.map.fillMark();
		},
		searchById(id) {
			this.loading();
			this.$store
				.dispatch('LOAD_HISTORICO_ID', {
					id: id,
				})
				.then((resp) => {
					this.handleResponse(resp);
				});
		},
		search() {
			if (!this.desde || !this.ducto || this.validation === false) return;
			this.loading();
			this.$store
				.dispatch('LOAD_HISTORICAL_LEGACY', {
					pipeline: this.selectedDucto,
					startDate: this.desde + ':00',
					endDate: this.hasta + ':00',
				})
				.then((resp) => {
					this.handleResponse(resp);
				});
		},
		handleResponse(resp) {
			console.log('Response:', resp);
			let response = resp.data;

			if (response.length === 0) {
				toastr.error('No se encontró información');
				this.loading();
				return;
			}

			this.historico = [];

			response.sort((a, b) => b.id - a.id);
			response.forEach((res) => {
				this.historicoMiddlePoints.push({
					id: res.id,
					km: res.km,
					fecha: `${res.date.split('T')[0]}`,
					hora: `${res.date.split('T')[1]}`,
					lat: res.lat,
					lng: res.lon,
					tipo: res.type,
					estado: res.state,
					municipio: res.city,
					isMP: true,
				});
			});
			this.jsonData = this.historicoMiddlePoints;
			this.historicoTemp = this.historicoMiddlePoints;

			console.log('Historico:', this.historicoMiddlePoints);

			if (this.leak_id) {
				var row = this.historico.find(
					(s) => s.id === parseInt(this.leak_id)
				);
				this.onSelectRow(row);
			} else {
				this.loading();
			}
		},
		onSelectRow(row) {
			this.isChartVisible = true;
			this.selectedEventRow = row;
			this.$refs.map.zoom(row);
		},
	},
	components: {
		SelectC,
		GoogleMaps,
		DatePicker,
		JsonEx,
		LoadingModal,
		Modal,
	},
	mounted() {
		this.jsonFields = Object.assign({}, this.eventsFields);
		this.historicoMark();
		this.$store
			.dispatch('LOAD_OPS_LEGACY')
			.then(() => {
				this.ductos = this.$store.state.optionsLegacy;
			})
			.catch((err) => {
				console.log('Error', err);
			});
		$('#map-div').css('z-index', '0');
		if (this.$route.params.id) {
			this.leak_detail = true;
			this.leak_id = this.$route.params.id;
			this.searchById(this.$route.params.id);
		}
	},
};
</script>

<style lang="scss" scoped src="./style.scss"></style>



// WEBPACK FOOTER //
// index.vue?0ed09e46